import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function HeroSection() {
  return <section className="bg-charcoal pt-16 pb-20 px-6 md:px-12 lg:px-24 flex flex-col items-center text-center min-h-screen justify-center" data-id="element-65">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto" data-id="element-66">
        <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl font-bold text-cream mb-6 leading-tight" data-id="element-67">
          AirFryer Criolla Express: <br className="hidden md:block" data-id="element-68" />
          <span className="text-amber" data-id="element-69">
            El Secreto del Bodegón en tu Mesada
          </span>
        </h1>

        <h2 className="font-sans text-lg md:text-2xl text-cream/90 mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-70">
          Cociná milanesas, empanadas y papas fritas perfectas en 15 minutos,
          sin olor a fritura y con el "crack" que amás.
        </h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative w-full max-w-2xl mx-auto mb-12 rounded-2xl overflow-hidden shadow-2xl shadow-amber/20" data-id="element-71">
          <img src="https://cdn.magicpatterns.com/uploads/gRuAmWVxqKaWJK3B49cBvN/AIRFRYER_CRIOLLA.png" alt="AirFryer Criolla Express en tablet y celular" className="w-full h-auto object-cover" data-id="element-72" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} data-id="element-73">
          <Button onClick={() => window.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth'
        })} data-id="element-74">
            ¡QUIERO MI COPIA AHORA!
          </Button>
        </motion.div>
      </motion.div>
    </section>;
}